
import { Component, Vue, Emit } from 'vue-property-decorator'
import { OderService, OrderReturnDto, OrderCancelInput, OrderRefuseInput } from "@/api/service-proxies";
import { __param } from "tslib";

@Component({

    components: {

    }
})
export default class ReturnsDialog extends Vue {
    teackimg: any = []
    selectedValue = ""

    orderNumber: string
    oderService = new OderService();
    orderReturn = new OrderReturnDto();
    orderCancelInput = new OrderCancelInput();
    refuseInput = new OrderRefuseInput();
    private dialogVisible: boolean = false
    dialogFormVisible: boolean = false

    isExporting = false

    public open(row) {
        this.dialogVisible = true
        this.orderNumber = row;

        this.initReturns();
    }
    close() {
        this.dialogVisible = false;
    }

    initReturns() {
        this.oderService.getOrderReturn(this.orderNumber).then((result) => {

            this.orderReturn = result;
        });
    }


    submit() {
        this.dialogVisible = false;
        this.orderCancelInput.orderNumer = this.orderNumber;
        this.orderCancelInput.orderRecordState = 5;
        this.oderService.setOrderCancel(this.orderCancelInput);
    }
    btnRefuse() {
        this.dialogFormVisible = true;
    }
    btnRefuseOk() {
        this.refuseInput.orderNumer = this.orderNumber;
        this.oderService.setOrderRefuse(this.refuseInput);
    }

    closeChirld(){
        this.dialogFormVisible = false;

    }
}




